export default __webpack_public_path__ + "static/media/ss-ramah.1414dfd5.jpg";